// extracted by mini-css-extract-plugin
export default {"footer":"Kr6_E4A2uc48sLtOk8S3","logo":"pO0O6ztRHQiIkcEhFUsC","copyright":"ZGJDgChPUCH3EnoHiFDz"};